// Only non-secret connection intent survives this tab's auth/verification reloads.
// Shopify proof is always requested afresh from the original opener. Nothing here
// grants access, selects a workspace, or extends the ten-minute popup bridge.
const KEY = 'm5m_shopify_return_v1';
const TTL = 10 * 60000;
let pending = null;
const storage = () => { try { return globalThis.sessionStorage; } catch { return null; } };
function pathFor(hash) {
  if (typeof hash !== 'string' || !/^#\/shopify\/connect(?:\?|$)/.test(hash)) return null;
  const params = new URLSearchParams(hash.split('?')[1] || '');
  if ([...params.keys()].some(key => !['origin', 'nonce', 'shop'].includes(key))) return null;
  if (params.size) {
    if (params.size !== 3 || !/^[a-f0-9]{64}$/.test(params.get('nonce') || '') || !/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(params.get('shop') || '')) return null;
    try {
      const origin = new URL(params.get('origin'));
      if (origin.origin !== params.get('origin') || !(origin.protocol === 'https:' || (origin.protocol === 'http:' && ['127.0.0.1', 'localhost'].includes(origin.hostname)))) return null;
    } catch { return null; }
  }
  return '/shopify/connect' + (params.size ? '?' + params : '');
}
export function clearShopifyBootRoute() {
  pending = null;
  try { storage()?.removeItem(KEY); } catch { /* memory-only fallback */ }
}
export function peekShopifyBootRoute() {
  let value = pending;
  if (!value) { try { value = JSON.parse(storage()?.getItem(KEY) || 'null'); } catch { /* invalid storage */ } }
  if (!value || !Number.isFinite(value.at) || Date.now() < value.at || Date.now() - value.at >= TTL || pathFor('#' + value.path) !== value.path) {
    clearShopifyBootRoute(); return null;
  }
  pending = {path:value.path,at:value.at};
  return pending.path;
}
export function rememberShopifyBootRoute(hash) {
  // These are the only cold reloads allowed to keep an unfinished auth return.
  if (/^#\/(?:signin|signup|verf-link|forgot|resethash|home)(?:\?|$)/.test(hash || '')) { peekShopifyBootRoute(); return; }
  const path = pathFor(hash);
  if (!path) { clearShopifyBootRoute(); return; }
  const previous = peekShopifyBootRoute();
  pending = {path,at:previous === path ? pending.at : Date.now()};
  try { storage()?.setItem(KEY,JSON.stringify(pending)); } catch { /* memory-only fallback */ }
}
export function takeShopifyBootRoute() {
  const path = peekShopifyBootRoute(); clearShopifyBootRoute(); return path;
}

// Leaving the auth task cancels its return, including explicit sign-out.
export function retainShopifyAuthReturn(hash) {
  if (!/^#\/(?:signin|signup|verf-link|forgot|resethash|home|shopify\/connect)(?:\?|$)/.test(hash || '')) clearShopifyBootRoute();
}
